// @flow
import * as React from 'react';
import { pure } from 'recompose';
import { Alert, Button, Col, Row, ToggleSwitch } from 'angieslist-react-components';
import { stylesColors } from 'angieslist-styles';
import Loader from 'angieslist-app-platform/lib/browser/Loader';
import { urlCatalog } from 'angieslist-app-platform';
import classNames from 'classnames';
import { map, sortBy } from 'lodash';

type Props = {
  isLoading: boolean,
  error: ?Error,
  cityName: string,
  postalCodes: Array<string>,
  selectedPostalCodes: Set<string>,
  advertisingPostalCodes: Array<string>,
  onClose: () => void,
  onBack: () => void,
  onClickPostalCode: (
    postalCode: string,
    analyticsEventName: string,
    analyticsProps?: {}
  ) => void,
  onClickAdZone: (
    analyticsEventName: string,
    analyticsProps?: {},
  ) => void,
};

class CityDetailsComponent extends React.Component<Props> {
  props: Props;

  handleZipClick = zip => () => {
    const isAdvertising = this.props.advertisingPostalCodes.includes(zip);
    const analyticsEventName = 'Service Area - Toggle Click';
    if (!isAdvertising) {
      this.props.onClickPostalCode(zip, analyticsEventName);
    } else {
      this.props.onClickAdZone(analyticsEventName);
    }
  }

  render(): React.Node {
    const {
      isLoading, error, cityName, postalCodes, onClose, onBack, selectedPostalCodes,
      advertisingPostalCodes,
    } = this.props;
    return (
      <div style={{ height: '100%' }}>
        <Row>
          <Button
            id="city-selection--postal-codes--go-back"
            className="text-secondary"
            bsStyle="link"
            bsSize="small"
            onClick={onBack}
          >
            <i className="icon icon-left-open-big" style={{ marginRight: '.5em' }} /> <strong>{cityName}</strong>
          </Button>
          <Button
            className="icon icon-close pull-right text-secondary pull-right"
            id="city-selection--postal-codes--close"
            bsStyle="link"
            bsSize="large"
            onClick={onClose}
          />
        </Row>
        <Row style={{ height: '95%', marginTop: '1em' }}>
          <Loader
            loading={isLoading}
            element={
              <Row className="category-row text-center" style={{ marginTop: '1em' }}>
                <i className="icon icon-load icon-spin icon-3x text-primary" />
              </Row>}
          >
            <Choose>
              <When condition={error}>
                <Alert bsStyle="danger">There was a problem searching for cities.  Please contact us at&nbsp;
                  <a
                    id="service-areas--add-service-area--store-error-link"
                    href={urlCatalog.global.businessCenterPhone()}
                    style={{ whiteSpace: 'nowrap' }}
                  >{urlCatalog.global.businessCenterPhoneText()}
                  </a> for assistance.
                </Alert>
              </When>
              <Otherwise>
                <div style={{
                height: '90%', overflowY: 'scroll', paddingRight: '1em',
              }}
                >
                  {map(sortBy(postalCodes), zip => (
                    <Row
                      key={zip}
                      style={{
                        borderBottom: `1px solid ${stylesColors.lightGray}`,
                        display: 'flex',
                        alignItems: 'center',
                        padding: '1em 0 0.5em 0.5em',
                      }}
                    >
                      <Col xs={6}>
                        <strong>{zip}</strong>
                      </Col>
                      <Col xs={6}>
                        {/* using the disabled attribute disables click events, which we
                            need for segment, so just apply the style instead */}
                        <ToggleSwitch
                          readOnly
                          className={classNames({
                            'pull-right': true,
                            'toggle-disabled': advertisingPostalCodes.includes(zip),
                          })}
                          checked={selectedPostalCodes.has(zip)}
                          onClick={this.handleZipClick(zip)}
                          id={`city-selection--toggle-${zip}`}
                        />
                      </Col>
                    </Row>
                  ))}
                </div>
              </Otherwise>
            </Choose>
          </Loader>
        </Row>
      </div>
    );
  }
}

export default (pure(CityDetailsComponent): any);



// WEBPACK FOOTER //
// ./src/app/browser/service-areas/CityDetails.js